<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @change="changeEmit"
      swapThreshold="1"
    >
      <v-card
        :key="input.id"
        v-for="input in realValue"
        class="d-flex justify-space-between align-center text-subtitle-2 mb-2 pl-1 px-3 py-2 grey--text text--darken-3"
      >
        <div class="text-caption">
          <v-icon class="option-drag-icon">mdi-drag</v-icon>
          <span class="grey--text text--darken-2">Type:</span>
          <b>{{input.type}}</b>
          <span class="mx-1">
            <b>-</b>
          </span>
          <span class="grey--text text--darken-2">Name:</span>
          <b>{{input.name}}</b> <sup>({{input.class}})</sup>
        </div>
        <div>
          <input-options v-if="isList(input.class) === true" :value="input.code" class="mr-2" />
          <v-btn small icon class="blue lighten-5" @click="editInput(input.code)">
            <v-icon size="15" color="blue">mdi-pencil</v-icon>
          </v-btn>
          <v-btn small icon>
            <v-icon size="15" color="red" @click="deleteInputDialog(input.code)">mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-card>
    </draggable>
    <v-dialog v-model="inputDelete.inputDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>Uyarı
        </v-card-title>
        <v-card-text>Seçili input'u silmek istediğinizden emin misiniz ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="inputDelete.inputDeleteDialog = false">İptal</v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="inputDelete.inputDeleteLoading"
            @click="deleteInput()"
          >Evet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-input v-model="editInputCode" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import OptionService from "@/services/OptionService";
import { mapState } from "vuex";
import EditInput from "./EditInput.vue";
import InputOptions from "./InputOptions.vue";

export default {
  name: "InputsList",
  components: {
    draggable,
    EditInput,
    InputOptions
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    }
  },
  data: () => ({
    inputDelete: {
      inputDeleteDialog: false,
      inputDeleteLoading: false,
      inputDeleteCode: ""
    },
    editInputCode: "",
    listInputs: ["select", "multiple", "radio", "checkbox"]
  }),
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    },
    ...mapState({
      activeOption: state => state.Option.option,
      activeOptionType: state => state.Option.optionType,
      apiLanguage: (state) => state.Language.apiLanguage
    })
  },
  methods: {
    isList(inputClass) {
      return !!this.listInputs.includes(inputClass);
    },
    changeEmit(value) {
      this.$emit("change", value);
    },
    inputEmit(value) {
      this.$emit("input", value);
    },
    optionStore() {
      const { optionName, optionType } = this.activeOptionType;
      let opt = { optionName, optionType },
        optionStore = "";

      if (opt.optionType == this.$moduleTypes.apiType) {
        optionStore = "Option/ApiOptions/";
      } else if (opt.optionType == this.$moduleTypes.modulesType) {
        optionStore = "Option/ModuleOptions/";
      } else if (opt.optionType == this.$moduleTypes.pluginsType) {
        optionStore = "Option/PluginOptions/";
      }

      return optionStore;
    },
    /**
     * Input CRUD işlemlerinden sonra listeyi güncelle
     */
    inputList() {
      let dispatch = this.optionStore() + "getInputList";

      const { optionName, optionType } = this.activeOptionType,
        optionSysName = this.activeOption.sysname,
        lang = this.apiLanguage;

      this.$store.dispatch(dispatch, { optionName, optionType, optionSysName, lang });
    },
    /**
     * Input'u siler
     *
     * @returns void
     */
    deleteInput() {
      const inputCode = this.inputDelete.inputDeleteCode;
      this.inputDelete.inputDeleteLoading = true;
      OptionService.deleteInput({ inputCode }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Input sistemden kaldırılmıştır", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.inputList();
          this.inputDelete.inputDeleteDialog = false;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
        this.inputDelete.inputDeleteLoading = false;
      });
    },
    editInput(inputCode) {
      this.editInputCode = inputCode;
    },
    /**
     * "İnput'u silmek istediğinizden emin misiniz ?" dialog'u
     * açar ve silinecek input code'unu hafızaya alır
     *
     * @param {number} inputCode
     *
     * @returns void
     */
    deleteInputDialog(inputCode) {
      this.inputDelete.inputDeleteCode = inputCode;
      this.inputDelete.inputDeleteDialog = true;
    }
  }
};
</script>

<style>
.option-drag-icon {
  cursor: grab;
  margin-right: 0.1em;
}
</style>